import { render, staticRenderFns } from "./DemandDetailDialog.vue?vue&type=template&id=1733a95a&scoped=true&"
import script from "./DemandDetailDialog.vue?vue&type=script&lang=ts&"
export * from "./DemandDetailDialog.vue?vue&type=script&lang=ts&"
import style0 from "./DemandDetailDialog.vue?vue&type=style&index=0&id=1733a95a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1733a95a",
  null
  
)

export default component.exports